import { render, staticRenderFns } from "./XmTip.vue?vue&type=template&id=3b6607fd&scoped=true"
import script from "./XmTip.vue?vue&type=script&lang=js"
export * from "./XmTip.vue?vue&type=script&lang=js"
import style0 from "./XmTip.vue?vue&type=style&index=0&id=3b6607fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6607fd",
  null
  
)

export default component.exports